<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-pedido') {
            next({ name: 'ven-pedido-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-pedido') {
            this.$router.replace({ name: 'ven-pedido-list' });
        }
    },
};
</script>
